import styled from "styled-components";
import { Button, buttonThemes } from "design-system";

import { largeScreen } from "src/shared/constants/screenSizes";

const ContactButton = styled(Button)`
  padding: 0 15px;
`;

const SecondaryContactButton = styled(ContactButton).attrs({
  theme: buttonThemes.SECONDARY
})`
  flex-grow: 1;
  margin: 5px;
  width: auto;
`;

const ButtonsContainer = styled.div`
  border: none;
  display: flex;
  flex-direction: ${({ isVertical }) => `${isVertical ? `column` : `row`}`};
  flex-wrap: ${({ isVertical }) => `${isVertical ? `wrap` : `nowrap`}`};
  margin: ${({ isVertical }) => `${isVertical ? "15px 0" : "auto"}`};
  min-height: ${({ isVertical }) => `${isVertical && "100px"}`};
  padding: ${({ isVertical }) => `${isVertical ? "15px" : "auto"}`};
  width: ${({ isVertical }) => `${isVertical ? "auto" : "100%"}`};
  @media (min-width: ${largeScreen}) {
    width: ${({ isVertical }) => `${isVertical ? "auto" : "460px"}`};
    margin: ${({ isVertical }) => `${isVertical ? "15px 0 0" : "auto"}`};
  }
`;

const PrimaryContactButton = styled(ContactButton)`
  flex-grow: 1;
  margin: 5px;
  width: auto;
`;

SecondaryContactButton.displayName = "SecondaryContactButton";
ButtonsContainer.displayName = "ButtonsContainer";
PrimaryContactButton.displayName = "PrimaryContactButton";

export { SecondaryContactButton, ButtonsContainer, PrimaryContactButton };
